import types from './types'

import redirects from './redirects'

const display = (error, config) => ({ type: types.display, error, config })

const hide = () => ({ type: types.clear })

const showFlowError = (error, config) => (dispatch, oldState) => {
  // redirect routes
  if (error?.flow?.redirect) {
    const { redirect, redirect_item } = error.flow

    dispatch(hide())

    const redirectAction = redirects[redirect]
    if (redirectAction?.[redirect_item]) redirectAction[redirect_item](dispatch, oldState())

    return
  }

  dispatch(display(error, config))
}

const hideFlowError = () => (dispatch) => dispatch(hide())

export { showFlowError, hideFlowError }